import { useState } from "react";
import { faqs } from "@/mocks/extra";

export default function FaqAccordion({ limit = faqs.length }: { limit?: number }) {
  const [openIndex, setOpenIndex] = useState<number>(0);
  return (
    <div className="divide-y divide-background-200 rounded-2xl border border-background-200 bg-background-50">
      {faqs.slice(0, limit).map((item, i) => {
        const open = openIndex === i;
        return (
          <div key={i}>
            <button
              type="button"
              onClick={() => setOpenIndex(open ? -1 : i)}
              aria-expanded={open}
              className="flex w-full items-center gap-3 px-5 py-4 text-left"
            >
              <span className="flex h-6 w-6 shrink-0 items-center justify-center rounded-md bg-primary-100 text-xs font-bold text-primary-700">
                {i + 1}
              </span>
              <span className="flex-1 text-sm font-semibold text-foreground-900">{item.q}</span>
              <i
                className={`ri-add-line text-xl text-foreground-400 transition-transform duration-300 ${open ? "rotate-45 text-primary-500" : ""}`}
                aria-hidden="true"
              />
            </button>
            <div
              className={`grid overflow-hidden transition-all duration-300 ${open ? "grid-rows-[1fr] pb-4" : "grid-rows-[0fr]"}`}
            >
              <div className="overflow-hidden">
                <p className="px-14 text-sm leading-relaxed text-foreground-600">{item.a}</p>
              </div>
            </div>
          </div>
        );
      })}
    </div>
  );
}